import { withFestivalExperience } from "@/lib/festivalExperience";
import {
  BACKEND_API_ROUTE,
  GET_USER_DETAILS_API, POOJA_LEADS,
  POOJA_WISHLIST_API,
} from "@/commons/api_routes";
import ImageWrapper from "@/components/ImageComponent/ImageWrapper";
import StarRating from "@/components/PoojaComponent/PoojaStarComponent";
import Modal from "@/components/productComponent/KnowMoreModal";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import {
  GETREQUESTAPI_AUTHENTICATED,
  POSTREQUESTAPI,
} from "@/pages/api/apiUtils";
import toast from "react-hot-toast";
import parse from "html-react-parser";
import {
  extractPoojaLangAndLocFromSlug,
  getCookieItem,
  getUserDetails, handleGuestLoginFlow,
  parsePoojaDescriptionRawHTML, transformFields,
} from "@/utils/utils";
import PoojaPackageComponent from "@/components/PoojaComponent/PoojaPackageComponent";
import MainModal from "@/components/modalcomponent/MainModal";
import {
  fetchCartIdByPoojaId,
  fetchPoojaFAQItems,
  fetchPoojaPackages,
  resolvePoojaPackageMap,
  fetchSinglePoojaItem, fetchSingleSEOByItem, findCustomFormData, fetchAllLanguages, fetchAllLocations
} from "@/pages/api";
import CustomAccordion2 from "@/components/CommonComponent/Accordian2";
import { PoojaReview } from "@/constants/app-constant";

import { useSelector } from "react-redux";
import { DEFAULT_SEO_VALUES } from "@/commons/constants";
import Head from "next/head";
import DownloadableComponent from "@/components/DownloadbleConten/DownloadableComponent";
import BlogModalComponent from "@/components/modalcomponent/BlogModalComponent";
import PoojaNotFound from "@/components/ErrorComponent/PoojaNotFound";
import { fileBuilder } from "@/sanity-client/sanity";
import InlineCheckout from "@/components/bookingComponent/InlineCheckout";
import StickyMobileContact from "@/components/v2/StickyMobileContact";
import GanpatiGreetingOverlay from "@/components/PoojaComponent/GanpatiGreetingOverlay";
import RelatedFestivalPoojas from "@/components/festival/RelatedFestivalPoojas";

const ProductPage = ({ seoData, noIndex, poojaCustomForm, poojaInitialData, packageInitialData, faqInitialData, initialLanguage, initialLocation, initialLanguageId, initialLocationId }) => {
  const router = useRouter();
  const [modalVisible, setModalVisible] = useState(false);
  const [poojaData, setPoojaData] = useState(poojaInitialData);
  const [packageData, setPackageData] = useState(packageInitialData);
  const [faqData, setfaqData] = useState(faqInitialData || []);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedPackageName, setSelectedPackageName] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [userData, setUserData] = useState(null);
  const [shareUrl, setShareUrl] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState(initialLanguage || "");
  const [selectedLocation, setSelectedLocation] = useState(initialLocation || "");
  const [selectedLocationId, setSelectedLocationId] = useState(initialLocationId || "");
  const [selectedLanguageId, setSelectedLanguageId] = useState(initialLanguageId || "");

  const [isValidForm, setIsValidForm] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [downloadLink, setDownloadLink] = useState("")
  const [notFound, setNotFound] = useState(!poojaInitialData)

  // ── Inline Checkout state ──────────────────────────────────────────────────
  const [showInlineCheckout, setShowInlineCheckout] = useState(false);
  const [selectedBookingPackage, setSelectedBookingPackage] = useState(null);
  const checkoutRef = useRef(null);

  const initialFormData = {};
  Object.keys(transformFields(poojaCustomForm?.fields)).forEach((field) => {
    initialFormData[field] = "";
  });

  const [formData, setFormData] = useState(initialFormData || {});
  const handleInputChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: { ...prev[e.target.name], value: e.target.value },
    }));
  };

  const handleSubmit = async () => {
    try {
      const URL = BACKEND_API_ROUTE + POOJA_LEADS;
      const accessToken = getCookieItem("accessToken");
      const formatBody = {
        phone: userData?.body?.phone || "",
        unstructuredData: JSON.stringify(formData),
        leadType: 1, // FOR BLOGS IT HAS TO BE 1
        referenceFrom: router.asPath,
      };

      const response = await POSTREQUESTAPI(URL, formatBody, accessToken);
      if (response.status === 201) {
        const data = await response.data;
        if (data.statusCode === 200) {
          window.open(downloadLink, '_blank'); // Opens the file in a new tab
          setIsOpen(false);
        } else {
          toast.error(data.message);
        }
      } else {
        toast("Something went wrong");
      }
    } catch (error) {
      console.log(error, '==error')
      toast.error("Error posting pooja leads. Please try again later.", error.message);
    }
  };
  useEffect(() => {
    if (!initialLanguage) setSelectedLanguage(getCookieItem("language_name")?.toLowerCase());
    if (!initialLocation) setSelectedLocation(getCookieItem("location_name")?.toLowerCase());
  }, [initialLanguage, initialLocation]);


  const { languages: reduxLanguages, locations: reduxLocations } = useSelector(
    (state) => state.locationandlanguages || {}
  );
  const validForm = () => {
    return Object.values(formData).every((field) => field.value && field.value !== "");
  };
  useEffect(() => {
    setIsValidForm(validForm());
  }, [formData]);


  useEffect(() => {
    setPoojaData(poojaInitialData);
    setPackageData(packageInitialData);
    setfaqData(faqInitialData || []);
    setSelectedLanguage(initialLanguage || "");
    setSelectedLocation(initialLocation || "");
    setSelectedLocationId(initialLocationId || "");
    setSelectedLanguageId(initialLanguageId || "");
    setNotFound(!poojaInitialData);
    setSelectedImage(null);
    setShowInlineCheckout(false);
  }, [poojaInitialData, packageInitialData, faqInitialData, initialLanguage, initialLocation, initialLocationId, initialLanguageId]);

  // Data is now fetched via SSR. Client-side fetching removed to avoid ReferenceErrors and redundancy.
  useEffect(() => {
    if (!poojaData && !notFound) {
      // Fallback for cases where SSR might have missed something or client-side navigation happened
      // However, with full SSR this should rarely be hit.
    }
  }, [router, selectedLanguageId, selectedLocationId, poojaData, notFound]);

  const checkAccessToken = async () => {
    const accessToken = getCookieItem("accessToken");
    if (accessToken) {
      try {
        const userData = await getUserDetails(accessToken);
        setUserData(userData);
      } catch (error) { }
    }
  };
  useEffect(() => {
    checkAccessToken();
  }, [router]);

  const postUserWishlistApi = async (poojaData) => {
    try {
      const wishlistApiUrl = BACKEND_API_ROUTE + POOJA_WISHLIST_API;
      const accessToken = getCookieItem("accessToken");
      // const isUserLoggedIn = localStorage.getItem("accessToken")
      const payload = {
        poojaId: poojaData._id,
      };
      if (accessToken) {
        const wishlistResponse = await POSTREQUESTAPI(
          wishlistApiUrl,
          payload,
          accessToken
        );
        if (wishlistResponse.status === 201) {
          if (wishlistResponse.data.statusCode === 200) {
            toast.success(wishlistResponse.data.message);
          } else {
            toast(wishlistResponse.data.error);
          }
        } else {
          toast(wishlistResponse.data.error);
        }
      } else {
        toast("You are not logged in. Please login to add items to wishlist ")
      }

    } catch (error) {
      if (error.response.status === 401) {
        toast("Please login to add item to wishlist");
      }
      toast.error("Error fetching wishlist API");
    }
  };

  const openModal = (packageData, packageName) => {
    document.body.style.overflow = "hidden";
    setSelectedPackage(packageData);
    setSelectedPackageName(packageName);
    setModalVisible(true);
  };

  const getQueryParam = (name) => {
    return router.query[name];
  };

  const closeQuoteModal = () => {
    setShowQuoteModal(false);
  };

  const closeModal = () => {
    document.body.style.overflow = "auto";
    setModalVisible(false);
  };

  const getUserDetailsApi = (accessToken) => {
    const userDetailUrl = BACKEND_API_ROUTE + GET_USER_DETAILS_API;
    return GETREQUESTAPI_AUTHENTICATED(userDetailUrl, accessToken);
  };

  const checkIfPoojaAlreadyInCart = async (poojaId) => {
    try {
      const cartIdResponse = await fetchCartIdByPoojaId(poojaId);
      if (cartIdResponse && cartIdResponse.status === 200) {
        if (
          cartIdResponse.data.statusCode === 200 &&
          cartIdResponse.data.body.length > 0
        ) {
          const cartId = cartIdResponse.data.body[0]._id;
          return cartId;
        } else {
          return null;
        }
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error checking if pooja is already in cart:", error);
      return null;
    }
  };

  // ── handleBookNow: called when user clicks "Book Now" on a package ───────────
  const handleBookNow = async (poojaId, packageId, packageType, fullPackageData) => {
    // Ensure a guest session exists (create one if needed)
    let accessToken = getCookieItem("accessToken");
    if (!accessToken) {
      const guestCreated = await handleGuestLoginFlow();
      if (!guestCreated) {
        toast.error("Something went wrong. Please try again.");
        return;
      }
    }

    // Set the selected package and reveal the inline checkout
    setSelectedBookingPackage({ poojaId, packageId, packageType, packageData: fullPackageData });
    setShowInlineCheckout(true);

    // Smooth scroll to the checkout panel after a brief paint delay
    setTimeout(() => {
      checkoutRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
  };

  // // kept for backward-compat (used by getQueryParam etc) — can be cleaned up later
  // const checkAccessToken = async (query = undefined) => {
  //   const redirecturl = `?redirecturl=${router.asPath}`;
  //   const accessToken = getCookieItem("accessToken");
  //   if (accessToken) {
  //     router.push({ pathname: "/booking", query: query });
  //   } else {
  //     const res = await handleGuestLoginFlow();
  //     if (res) await checkAccessToken(query);
  //   }
  // };

  const handleQuoteButton = () => {
    setShowQuoteModal(true);
  };

  useEffect(() => {
    if (poojaData) {
      const url = `${process.env.NEXT_PUBLIC_SITE_URL}/${selectedLanguage}/${selectedLocation}/pooja/${poojaData.body[0].slug}`;
      setShareUrl(url);
    }
  }, [poojaData]);

  const shareViaWhatsApp = () => {
    const message = `Hi , I am planning to book this puja ${shareUrl} . Please respond to me on whatsapp here`;
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`);
  };
  const canonical = process.env.NEXT_PUBLIC_SITE_URL + router.asPath?.toLowerCase();
  const seoImage =
    seoData?.seoPoojaMedia?.length && seoData?.seoPoojaMedia[0]?.mediaUrl && typeof seoData?.seoPoojaMedia[0]?.mediaUrl === 'string'
      ? seoData?.seoPoojaMedia[0]?.mediaUrl.split('?')[0]
      : DEFAULT_SEO_VALUES.imageLink;
  const handleOnDownloadItemClick = (item) => {
    setDownloadLink(fileBuilder(item?.File))
    const accessToken = getCookieItem('accessToken')
    if (!accessToken) {
      setIsOpen(true)
    } else {
      handleSubmit()
    }
  }
  return (
    <>
      <Head>
        {(noIndex || router.asPath?.includes('/english/bangalore/pooja/navagraha-japa') || router.asPath?.includes('/english/bangalore/pooja/chandra-graha-japa')) && (
          <meta name="robots" content="noindex, follow" />
        )}
        <title>{seoData?.title}</title>
        <meta name="description" content={seoData?.description} />
        <meta
          property="og:image"
          content={seoImage}
        />
        <meta
          name="image"
          content={seoImage}
        />
        <link rel="canonical" href={canonical} />
        <meta name="og:title" content={seoData?.title} />
        <meta name="og:description" content={seoData?.description} />
        <meta name="og:type" content="website" />
        <meta name="og:keywords" content={seoData?.keywords} />
        <meta name="keywords" content={seoData?.keywords} />
        <meta name="og:url" content={process.env.NEXT_PUBLIC_SITE_URL} />
        <meta name="og:site_name" content="Book My Pooja" />
        <meta name="og:locale" content="en_US" />
        <meta name="og:locale:alternate" content="en_US" />
        <meta name="og:locale:alternate" content="en_IN" />
        <meta name="twitter:description" content={seoData?.description} />
        <meta name="facebook-domain-verification" content="82hoqhqt8pbrvz70rapxaav9pnsnpk" />
      </Head>
      <GanpatiGreetingOverlay
        poojaSlug={poojaData?.body?.[0]?.slug}
        location={selectedLocation}
        language={selectedLanguage}
      />
      <div>
        {poojaData && (
          <div className="pt-10 md:pt-20 -z-20 bg-white flex flex-col md:flex-row md:gap-12 lg:gap-16 xl:gap-20 px-0 md:px-20 lg:px-32 xl:px-35 2xl:px-44 3xl:px-56 4xl:px-64">
            <div
              className="w-full md:w-1/4 flex justify-center md:justify-end md:sticky md:top-36 md:h-fit md:self-start"
            >
              <div className="flex flex-col w-full justify-start">
                <div className="flex px-6 md:px-0 xl:w-[444px] 2xl:w-[500px] 3xl:w-[550px] 4xl:w-[600px] flex-row justify-center lg:justify-start xl:justify-end bg-white overflow-hidden rounded-2xl">
                  <div className="w-full h-[300px] xxs:h-[330px] xs:h-[420px] sm:h-[480px] lg:w-[400px] xl:w-[444px] lg:h-[464px] 2xl:w-[500px] 2xl:h-[530px] 3xl:w-[550px] 3xl:h-[590px] 4xl:w-[600px] 4xl:h-[650px] relative">
                    {selectedImage ? (
                      <ImageWrapper
                        src={selectedImage}
                        alt="Selected pooja images"
                        className="bg-black overflow-hidden object-fill rounded-2xl"
                      />
                    ) : (
                      <ImageWrapper
                        src={
                          poojaData.body[0].media &&
                            poojaData.body[0].media.length > 0
                            ? poojaData.body[0].media[0].mediaUrl
                            : "/images/Poojas1.jpg"
                        }
                        alt={poojaData.body[0]?.name || "BookMyPooja"}
                        className="overflow-hidden object-cover border rounded-2xl "
                      />
                    )}
                    <div className="flex flex-col gap-1 md:gap-2 absolute group-hover:opacity-100 bottom-6 md:bottom-8 right-3 md:right-4 bg-clip-padding text-white tracking-wider">
                      <button
                        onClick={() => postUserWishlistApi(poojaData.body[0])}
                        className="rounded-full cusror-pointer bg-opacity-50 hover:bg-opacity-20 bg-inherit backdrop-blur-lg p-1 sm:p-1.5 w-9 h-9 sm:w-11 sm:h-11 md:w-10 md:h-10 lg:w-12 lg:h-12 flex items-center justify-center"
                      >
                        <ImageWrapper
                          src="/icons/whiteHeart.svg"
                          alt="White heart"
                          width={24}
                          height={24}
                          className="hover:scale-110 transition-all duration-200"
                        />
                      </button>
                      <button
                        onClick={shareViaWhatsApp}
                        className="rounded-full cursor-pointer bg-opacity-50 hover:bg-opacity-20 bg-inherit backdrop-blur-lg p-1 sm:p-1.5 w-9 h-9 sm:w-11 sm:h-11 md:w-10 md:h-10 lg:w-12 lg:h-12 flex items-center justify-center"
                      >
                        <ImageWrapper
                          src="/icons/share.svg"
                          alt="Share button"
                          width={24}
                          height={24}
                          className="hover:scale-110 transition-all duration-200"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex px-6 md:px-1 md:w-[444px] 2xl:w-[500px] 3xl:w-[550px] 4xl:w-[600px] right-0 flex-row gap-[10px] items-start 2xl:items-end justify-start overflow-x-auto scrollbar-hide pr-4 py-3">
                  {poojaData.body[0].media.map((mediaLink, index) => {
                    return (
                      <div
                        key={index}
                        className="relative flex-none w-[76px] h-[80px] border rounded-lg overflow-hidden cursor-pointer transition-transform duration-200 ease-in-out hover:scale-105 bg-black"
                        onClick={() => setSelectedImage(mediaLink.mediaUrl)}
                      >
                        <ImageWrapper
                          src={mediaLink.mediaUrl}
                          alt={poojaData.body[0].name}
                          fill
                          className="object-cover"
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="w-full md:w-2/4 md:ml-auto overflow-auto bg-white">
              <h4 className="hidden md:flex flex-row flex-wrap tracking-wide text-xs text-Default pb-4">
                <p>
                  {selectedLocation
                    ? selectedLocation.replace(/-/g, " ") + " / "
                    : ""}
                  {selectedLanguage
                    ? selectedLanguage.replace(/-/g, " ") + " /"
                    : ""}{" "}
                  <span onClick={() => { router.push(`/${selectedLanguage.toLowerCase()}/${selectedLocation.toLowerCase()}/pooja`) }} className="hover:cursor-pointer hover:text-BluntRed underline   " >Pooja Services </span> <span className="mx-1">/</span>
                </p>
                <span className="text-BluntRed font-medium">
                  {poojaData.body[0].name.replace(/-/g, " ")}
                </span>
              </h4>
              <div className=" md:overflow-y-scroll md:scrollbar-hide">
                <h4 className="text-xl lg:text-4xl px-6 md:px-0 leading-8 lg:leading-tight tracking-wide text-Default font-medium lg:font-normal">
                  {poojaData.body[0].name.replace(/-/g, " ")}
                </h4>
                <div className="flex flex-col md:flex-row md:items-center md:gap-4">
                  <div className="flex px-6 md:px-0 flex-row text-left justify-start gap-4 py-2">
                    <StarRating
                      rating={4}
                      layout="responsive"
                      canChangeRating={false}
                      defaultStars={5}
                    />
                    {/* <p className="text-[#94a3b8] text-xs pt-0.5">
                    reviews{" "}
                    <span className="font-semibold text-Default">1.2k</span>
                  </p> */}
                  </div>
                  {/* <div className="flex px-6 md:px-0 text-Default w-auto py-2">
                  <b className="font-medium rounded-xl px-4 py-2 tracking-wide leading-6 bg-[#CBD5E180]">
                    20% off
                  </b>
                </div> */}
                </div>
                <p className="flex text-sm lg:text-base px-6 md:px-0 text-Default leading-5 md:leading-6 tracking-normal py-2">
                  {poojaData.body[0].shortDescription}
                </p>
                {userData ? (
                  <div className="px-6 md:px-0">{userData._id}</div>
                ) : (
                  ""
                )}
                {/* Packages Section */}
                {packageData &&
                  packageData.body &&
                  packageData.body.length > 0 && (
                    <div className="px-6 md:px-0">
                      <h3 className="text-base md:text-xl font-medium text-Default pt-4 md:pt-6 leading-7 tracking-wide">
                        Pooja Packages
                      </h3>
                      <div className="flex overflow-x-auto scrollbar-hide py-12">
                        {/* basic package */}
                        {packageData.body[0].basic && (
                          <PoojaPackageComponent
                            packageData={packageData.body[0].basic}
                            packageName="Basic"
                            onBookNow={handleBookNow}
                            onAddToCart={checkAccessToken}
                            openModal={openModal}
                            poojaId={poojaData.body[0]._id}
                            packageId={packageData.body[0]._id}
                            packageType="basic"
                          />
                        )}
                        {/* standard package */}
                        {packageData.body[0].standard && (
                          <PoojaPackageComponent
                            packageData={packageData.body[0].standard}
                            packageName="Standard"
                            onBookNow={handleBookNow}
                            onAddToCart={checkAccessToken}
                            openModal={openModal}
                            poojaId={poojaData.body[0]._id}
                            packageId={packageData.body[0]._id}
                            packageType="standard"
                          />
                        )}

                        {/* Premium package */}
                        {packageData.body[0].premium && (
                          <PoojaPackageComponent
                            packageData={packageData.body[0].premium}
                            packageName="Premium"
                            onBookNow={handleBookNow}
                            onAddToCart={checkAccessToken}
                            openModal={openModal}
                            poojaId={poojaData.body[0]._id}
                            packageId={packageData.body[0]._id}
                            packageType="premium"
                          />
                        )}
                      </div>

                      {/* ── INLINE CHECKOUT PANEL ── */}
                      <div ref={checkoutRef}>
                        {showInlineCheckout && selectedBookingPackage && (
                          <InlineCheckout
                            key={`${selectedBookingPackage.packageId}-${selectedBookingPackage.packageType}`}
                            bookingPackage={selectedBookingPackage}
                            poojaData={poojaData.body[0]}
                            selectedLocation={selectedLocation}
                            selectedLanguage={selectedLanguage}
                            selectedLocationId={selectedLocationId}
                            selectedLanguageId={selectedLanguageId}
                            onClose={() => {
                              setShowInlineCheckout(false);
                              setSelectedBookingPackage(null);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  )}
                {
                  isOpen && (
                    <BlogModalComponent data={transformFields(poojaCustomForm?.fields)} onInputChange={handleInputChange} onFormSubmit={handleSubmit} validForm={isValidForm} isOpen={isOpen} onClose={() => setIsOpen(false)} formData={formData} />
                  )
                }
                {
                  poojaCustomForm && (
                    <DownloadableComponent
                      downloads={poojaCustomForm?.downlodableContentLink}
                      onItemClick={handleOnDownloadItemClick}
                    />
                  )
                }
                <div className="flex flex-col lg:flex-row px-6 md:px-0 py-10 md:py-6 md:pb-10 md:gap-4">
                  <p className="text-sm text-Default font-base leading-5 tracking-normal">
                    Looking for a custom package? Click here to tailor your
                    perfect pooja experience!
                  </p>
                  <button
                    onClick={handleQuoteButton}
                    className="border border-BluntRed rounded-md w-full text-base py-2 md:py-4 mt-4 md:mt-0 font-medium text-BluntRed"
                    type="button"
                  >
                    Get a Quote
                  </button>
                </div>
                {/* Festival Experience — PDP cross-link, always below booking */}
                <RelatedFestivalPoojas currentPoojaSlug={poojaData.body[0]?.slug} />
                <hr className="border-solid border-Default opacity-30" />
                <div className=" flex flex-col gap-5 md:pt-6 ">
                  <h3 className="text-base md:text-xl px-6 md:px-0 font-medium text-Default pt-4 leading-7 tracking-wide">
                    Our Promise
                  </h3>
                  <div className="flex flex-row overflow-x-auto px-6 md:px-0 text-[10px] leading-4 text-center text-Default scrollbar-hide gap-4 pb-8">
                    <div className="flex flex-col w-24">
                      <div className="flex-none w-16 h-16 border border-[#8A1C2333] rounded-full p-4 mx-3 flex items-center justify-center">
                        <ImageWrapper
                          src="/icons/Group7570.svg"
                          alt="Experienced preists"
                          width={32}
                          height={32}
                        />{" "}
                      </div>

                      <p className="py-3">Experienced Pandits</p>
                    </div>
                    <div className="flex flex-col w-24">
                      <div className="flex-none w-16 h-16 border border-[#8A1C2333] rounded-full p-4 mx-3 flex items-center justify-center">
                        <ImageWrapper
                          src="/icons/paper.svg"
                          alt="Paper icon"
                          width={32}
                          height={32}
                        />
                      </div>
                      <p className="py-3">Vedic Standards & Procedures</p>
                    </div>
                    <div className="flex flex-col w-24">
                      <div className="flex-none w-16 h-16 border border-[#8A1C2333] rounded-full p-4 mx-3 flex items-center justify-center">
                        <ImageWrapper
                          src="/icons/star.svg"
                          alt="Great Experience"
                          width={32}
                          height={32}
                        />{" "}
                      </div>

                      <p className="py-3">100% Puja Benefits</p>
                    </div>
                    <div className="flex flex-col w-24">
                      <div className="flex-none w-16 h-16 border border-[#8A1C2333] rounded-full p-4 mx-3 flex items-center justify-center">
                        <ImageWrapper
                          src="/icons/Group7565.svg"
                          alt="High Quality"
                          width={32}
                          height={32}
                        />{" "}
                      </div>

                      <p className="py-3">High Quality Samgri</p>
                    </div>
                    <div className="flex flex-col w-24">
                      <div className="flex-none w-16 h-16 border border-[#8A1C2333] rounded-full p-4 mx-3 flex items-center justify-center">
                        <ImageWrapper
                          src="/icons/headphone-dummy.svg"
                          alt="Professional"
                          width={32}
                          height={32}
                        />
                      </div>

                      <p className="py-3">Professional Guidance and Support</p>
                    </div>

                    <div className="flex flex-col w-24">
                      <div className="flex-none w-16 h-16 border border-[#8A1C2333] rounded-full p-4 mx-3 flex items-center justify-center">
                        <ImageWrapper
                          src="/icons/star.svg"
                          alt="Great Experience"
                          width={32}
                          height={32}
                        />
                      </div>
                      <p className="py-3">Guaranteed Punctuality</p>
                    </div>
                  </div>
                </div>
                <hr className="border-solid border-Default opacity-30" />
                <div className="px-6 md:px-0 md:pb-8 text-justify">
                  <h3>
                    {parse(
                      parsePoojaDescriptionRawHTML(poojaData.body[0].description)
                    )}
                  </h3>
                </div>
                <hr className="border-solid border-Default opacity-30" />
                <h1 className="text-base md:text-xl px-6 md:px-0 font-medium text-Default pt-4 md:pt-8 leading-7 tracking-wide py-5 md:py-0">
                  FAQ (Frequently Asked Questions)
                </h1>
                <hr className="border-solid border-Default opacity-30 flex md:hidden" />
                {faqData && faqData.length > 0 && (
                  <div className="self-start text-start">
                    <CustomAccordion2
                      items={faqData}
                      className="px-6 md:px-0 pt-8 md:pt-3 pb-12 md:pb-8"
                    />
                    {/* {JSON.stringify(faqData)} */}
                  </div>
                )}
                <hr className="border-solid border-Default opacity-30" />
                <div>
                  <PoojaReview poojaData={poojaData.body[0]._id} />
                </div>
              </div>
            </div>
          </div>
        )}
        {modalVisible ? (
          <Modal
            onClose={() => closeModal()}
            isOpen={() => openModal()}
            selectedPackage={selectedPackage}
            selectedPackageName={selectedPackageName}
            poojaDetails={poojaData.body[0]}
          />
        ) : (
          ""
        )}
        {showQuoteModal && (
          <MainModal
            modalData={{
              modalTitle: "Pooja Query",
              modalFirstNamePlaceholder: "Enter your first name",
              modalLastNamePlaceholder: "Enter your Last name",
              modalPhoneNumberPlaceholder: "Enter your mobile number",
              modalEmailPlaceholder: "abcd@gmail.com",
            }}
            poojaDetails={poojaData.body[0]}
            isOpen={handleQuoteButton}
            onClose={() => closeQuoteModal()}
            userData={userData?._id}
          />
        )}
        {notFound && <PoojaNotFound />}
      </div>
      <StickyMobileContact />
    </>
  );
};


async function getPageServerSideProps(context) {
  try {
    const { params } = context;
    const { slug, language, location } = params;

    // 1. Fetch all languages and locations to find IDs
    const [languagesRes, locationsRes] = await Promise.all([
      fetchAllLanguages(1), // Assuming status 1 for active
      fetchAllLocations()
    ]);

    let languageId = "";
    let locationId = "";
    let languageName = "";
    let locationName = "";

    if (languagesRes?.status === 200 && languagesRes?.data?.statusCode === 200) {
      const langItem = languagesRes.data.body.find(item => item.languageName?.toLowerCase() === language?.toLowerCase());
      if (langItem) {
        languageId = langItem._id;
        languageName = langItem.languageName;
      }
    }

    if (locationsRes?.status === 200 && locationsRes?.data?.statusCode === 200) {
      const locItem = locationsRes.data.body.find(item => item.locationName?.toLowerCase() === location?.toLowerCase());
      if (locItem) {
        locationId = locItem._id;
        locationName = locItem.locationName;
      }
    }

    // Unknown language/location slug → real 404 instead of a soft-404 page that Google indexes
    const languagesLoaded = languagesRes?.status === 200 && languagesRes?.data?.statusCode === 200;
    const locationsLoaded = locationsRes?.status === 200 && locationsRes?.data?.statusCode === 200;
    if ((languagesLoaded && !languageId) || (locationsLoaded && !locationId)) {
      return { notFound: true };
    }

    // 2. Fetch SEO and Custom Form Data
    const query = `?poojaname=${slug}&location=${location}&language=${language}`;
    const [seoRes, formRes] = await Promise.all([
      fetchSingleSEOByItem(query),
      findCustomFormData(`${language}/${location}/pooja/${slug}`)
    ]);

    const seoData = (seoRes?.status === 200 && seoRes?.data?.statusCode === 200) ? seoRes.data.body : DEFAULT_SEO_VALUES;
    const poojaCustomForm = (formRes?.status === 200 && formRes?.data?.statusCode === 200) ? formRes.data.body : null;

    // 3. Fetch Core Pooja Data
    let poojaInitialData = null;
    let packageInitialData = null;
    let faqInitialData = [];

    if (slug && languageId && locationId) {
      const poojaRes = await fetchSinglePoojaItem(slug, {
        language: languageId,
        location: locationId,
      });

      // Backend answers a missing pooja with HTTP 200 + { statusCode: 400, message: "No Pooja Found" }.
      // Serve a 404 so Google drops the URL instead of indexing a generic "Book My Pooja" page.
      if (poojaRes?.status === 200 && (poojaRes?.data?.statusCode !== 200 || !poojaRes?.data?.body?.length)) {
        return { notFound: true };
      }

      if (poojaRes?.status === 200 && poojaRes?.data?.statusCode === 200) {
        poojaInitialData = poojaRes.data;
        const poojaItem = poojaInitialData.body[0];
        
        // Fetch Packages and FAQs
        let packageIds = poojaItem.packages;
        try {
          const mappedRes = await resolvePoojaPackageMap(poojaItem._id, locationId, languageId);
          if (mappedRes?.status === 200 && mappedRes?.data?.statusCode === 200 && mappedRes?.data?.body?.packageId) {
             packageIds = mappedRes.data.body.packageId;
          }
        } catch (error) {
          console.error("Failed to resolve mapped package", error);
        }

        const faqIds = poojaItem.poojaFAQ;
        const isEPooja = locationName === "E-Pooja" || location?.toLowerCase() === "e-pooja";

        const [packageRes, faqRes] = await Promise.all([
          packageIds ? fetchPoojaPackages(packageIds, isEPooja) : Promise.resolve(null),
          faqIds?.length > 0 ? fetchPoojaFAQItems(faqIds, isEPooja) : Promise.resolve(null)
        ]);

        if (packageRes?.status === 200 && packageRes?.data?.statusCode === 200) {
          packageInitialData = packageRes.data;
        }

        if (faqRes?.status === 200 && faqRes?.data?.statusCode === 200) {
          faqInitialData = faqRes.data.body;
        }
      }
    }

    // No admin SEO entry for this pooja → build a specific title instead of the site-wide default,
    // otherwise Google rewrites the snippet from random page text (e.g. the "Login / Sign Up" button).
    const poojaName = poojaInitialData?.body?.[0]?.poojaName || poojaInitialData?.body?.[0]?.name;
    const resolvedSeoData = seoData === DEFAULT_SEO_VALUES && poojaName
      ? {
          ...DEFAULT_SEO_VALUES,
          title: `${poojaName} in ${locationName}${languageName ? ` (${languageName})` : ""} | Book Pandit Online | BookMyPooja`,
          description: `Book ${poojaName} in ${locationName} with verified ${languageName || ""} pandits on BookMyPooja. Transparent pricing, samagri options and hassle-free online booking.`.replace(/\s+/g, " "),
        }
      : seoData;

    return {
      props: {
        seoData: resolvedSeoData,
        // Pooja data couldn't be loaded (API hiccup) — keep the page usable but out of the index
        noIndex: !poojaInitialData,
        poojaCustomForm,
        poojaInitialData,
        packageInitialData,
        faqInitialData,
        initialLanguage: languageName,
        initialLocation: locationName,
        initialLanguageId: languageId,
        initialLocationId: locationId
      }
    };
  } catch (error) {
    console.error('Error fetching data in getServerSideProps:', error.message);
    return {
      props: {
        seoData: DEFAULT_SEO_VALUES,
        noIndex: true,
        poojaCustomForm: null,
        poojaInitialData: null,
        packageInitialData: null,
        faqInitialData: [],
        initialLanguage: "",
        initialLocation: "",
        initialLanguageId: "",
        initialLocationId: ""
      }
    };
  }
}

export default ProductPage;

// Festival layer resolved alongside the page data (renders nothing if no campaign).
export const getServerSideProps = withFestivalExperience("pdp", getPageServerSideProps);
